import {
  updateDirectusUser,
  updateItemInCollection,
} from "directus/src/operations";

export async function updateTimesheetEntry({ id, item }) {
  try {
    const query = {
      fields: [
        "id",
        "employee.first_name",
        "milestone.name",
        "job.name",
        "project.name",
        "date",
        "logged_hours",
        "description",
        "approved_hours",
        "unapproved_hours",
        "reason",
      ],
    };

    const data = await updateItemInCollection("timesheet", id, item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function updateUsersLatestReviewedDate({ userId }) {
  try {
    const query = {
      fields: ["date_reviewed"],
    };

    const item = {
      date_reviewed: new Date(),
    };
    const response = await updateDirectusUser(userId, item, query);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
